"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arraysAreEqual = void 0;
var object_helpers_1 = require("./object.helpers");
/* eslint-disable @typescript-eslint/no-explicit-any */
exports.arraysAreEqual = function (array1, array2) {
    if (!Array.isArray(array1) || !Array.isArray(array2)) {
        return false;
    }
    return (array1.length === array2.length &&
        array1.every(function (value, index) {
            if (value !== undefined && array2[index] === undefined) {
                return false;
            }
            if (Array.isArray(value)) {
                return exports.arraysAreEqual(value, array2[index]);
            }
            else if (typeof value === 'object' && value !== null) {
                return object_helpers_1.objectsAreEqual(value, array2[index]);
            }
            else {
                return value === array2[index];
            }
        }));
};
